export default "__VITE_PUBLIC_ASSET__ee6bc261__"